<template >
  <v-app class="back">
    <v-container fluid class="doc">
      <v-row justify="start" class="my-4 ml-1">
        <span class="display-1 titulo font-weight-bold">Classificações</span>
      </v-row>

      <!-- LISTAGEM -->
      <v-row>
        <v-col cols="12" sm="12" md="9">
          <v-card outlined class="borda" flat width="100%">
            <v-data-table
              no-data-text="Nenhuma classificação cadastrada"
              hide-default-footer
              disable-sort
              :headers="cabecalho"
              :items="classificacoes"
              :items-per-page="items_per_pag"
              class="elevation-0"
              :loading="loading"
              loading-text="Carregando itens..."
            >
              <template v-slot:item.acao="{ item }">
                <v-tooltip top color="black" v-if="!editModulo">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" text>
                      <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>
                    Sem autorização para
                    <span class="orange--text">editar</span> ou
                    <span class="red--text">excluir</span>
                  </span>
                </v-tooltip>
                <v-menu offset-x v-if="editModulo">
                  <template v-slot:activator="{ on }">
                    <v-btn icon text v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <div v-for="(iten, index) in opcoes" :key="index">
                      <v-list-item @click="menu(iten,item)">
                        <v-icon>{{ iten.icon }}</v-icon>
                        <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                      </v-list-item>
                    </div>
                  </v-list>
                </v-menu>
              </template>

              <template v-slot:footer>
                <v-row justify="center" class="mb-2">
                  <v-btn
                    v-if="items_per_pag > 10"
                    @click="items_per_pag -= 10"
                    text
                    color="#1F36C7"
                  >Mostrar menos</v-btn>
                  <v-btn
                    v-if="formData.length > items_per_pag"
                    @click="carregarMais()"
                    text
                    color="#1F36C7"
                  >Carregar mais</v-btn>
                </v-row>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col sm="12" md="3">
          <v-row>
            <v-card flat width="100%" height="100%" class="mr-4 borda" v-if="editModulo">
              <v-col class="mr-8">
                <v-btn
                  @click="novaClassificacao()"
                  large
                  rounded
                  block
                  class
                  style="background-color: #283480  !important;"
                >
                  <v-icon style="color: #00ffd4 !important" class="mr-1">mdi-account-details</v-icon>
                  <span class="white--text">Nova classificação</span>
                </v-btn>
              </v-col>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <!-- DIALOG CADASTRAR/EDITAR -->
    <v-dialog v-model="dialog_classificacao" persistent width="900px">
      <v-form ref="form" v-model="valid" @submit.prevent="save()">
        <v-card flat class="borda">
          <v-card-title class="ma-2">
            Nova classificação
            <v-spacer></v-spacer>
            <v-btn icon text @click="close()">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="12" class="mb-n5">
                <span class="font-weight-bold black--text">Descrição *</span>
                <v-text-field
                  required
                  :rules="requiredRules"
                  v-model="formData.classificacao_descricao"
                  solo
                  dense
                  flat
                  outlined
                  :autofocus="true"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row class="mb-4" no-gutters justify="center">
              <v-btn
                class="mr-2"
                @click="close()"
                rounded
                style="color: #283480 !important"
                outlined
              >Cancelar</v-btn>
              <v-btn
                class="ml-2"
                rounded
                style="background-color: #283480  !important; color:#00FFD4  !important"
                :loading="loadingSalvar"
                :disabled="loadingSalvar"
                @click="save()"
              >
                <v-icon>mdi-content-save</v-icon>
                <span>Salvar</span>
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- DIALOG DELETAR -->
    <v-dialog v-model="dialog_delete" persistent max-width="400">
      <v-card class="borda" flat>
        <v-card-title class="headline">Tem certeza que deseja deletar este grupo?</v-card-title>
        <v-card-text>Se deletar este grupo ele não poderá ser recuperado!</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined rounded color="#283480" @click="dialog_delete = false">Cancelar</v-btn>
          <v-btn
            style="background-color: #283480  !important; color:#00FFD4  !important"
            rounded
            :loading="loadingSalvar"
            :disabled="loadingSalvar"
            @click="deleteItem(), dialog_delete = false"
          >Sim, tenho certeza</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Api from "@/common/api.helper";

export default {
  data: () => {
    return {
      loading: false,
      loadingSalvar: false,
      opcoes: [
        { nome: "⠀Editar", icon: "mdi-pencil-outline" },
        { nome: "⠀Excluir", icon: "mdi-delete-outline" },
      ],
      menu1: false,
      menu2: false,
      dialog_classificacao: false,
      dialog_delete: false,
      classificacoes: [],
      formData: {
        id_classificacao: "",
        classificacao_descricao: "",
      },
      valid: true,
      requiredRules: [(v) => !!v || "Campo Obrigatório."],
      items_per_pag: 10,
      cabecalho: [
        { text: "Descrição", align: "start", value: "classificacao_descricao" },
        { text: "Ações", align: "end", sortable: false, value: "acao" },
      ],
      editModulo: false,
    };
  },
  computed: {},
  created() {
    this.getClassificacoes();
    this.validaEdicaoModulo();
  },
  methods: {
    menu(opcao, item) {
      this.formData.id_classificacao = item.id_classificacao;
      if (opcao.nome === "⠀Excluir") {
        this.dialog_delete = true;
      } else if (opcao.nome === "⠀Editar") {
        this.formData = {
          id_classificacao: item.id_classificacao,
          classificacao_descricao: item.classificacao_descricao,
        };
        this.dialog_classificacao = true;
      }
    },

    deleteItem() {
      this.loadingSalvar = true;
      Api.delete(`/classificacoes/` + this.formData.id_classificacao)
        .then((response) => {
          if (!response.data.errors) {
            this.$toast.success("Excluído com sucesso!");
            this.formData.id_classificacao = "";
            this.getClassificacoes();
            this.loadingSalvar = false;
          } else {
            this.$toast.warning(response.data.errors);
            this.formData.id_classificacao = "";
            this.loadingSalvar = false;
          }
        })
        .catch((err) => {
          this.loadingSalvar = false;
          throw err;
        });
    },

    save() {
      this.loadingSalvar = true;
      if (this.$refs.form.validate()) {
        var endpoint = "";
        var msg = "";
        if (!this.formData.id_classificacao) {
          // CADASTRAR
          endpoint = "/classificacoes";
          msg = "Castradado com sucesso!";
        } else {
          // EDITAR
          endpoint = "/classificacoes/" + this.formData.id_classificacao;
          msg = "Editado com sucesso!";
        }
        Api.post(endpoint, this.formData)
          .then((response) => {
            if (response) {
              this.loadingSalvar = false;
            }
            this.loadingSalvar = false;
            this.$toast.success(msg);
            this.getClassificacoes();
            this.$refs.form.resetValidation();
            this.close();
          })
          .catch((err) => {
            this.loadingSalvar = false;
            this.$toast.error("Oops! Ocorreu um erro.");
            throw err;
          });
      }
    },

    getClassificacoes() {
      this.loading = true;
      Api.get(`/classificacoes`)
        .then((response) => {
          if (response.data.data) {
            this.classificacoes = response.data.data;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          throw err;
        });
    },

    carregarMais() {
      if (this.classificacoes.length > this.items_per_pag) {
        this.items_per_pag += 10;
      }
    },

    close() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      this.dialog_classificacao = false;
      this.formData = {
        id_classificacao: "",
        classificacao_descricao: "",
      };
    },

    novaClassificacao() {
      this.dialog_classificacao = true;
    },

    async validaEdicaoModulo() {
      this.editModulo = await Api.validaEdicaoModulo(
        this.$router.currentRoute.path
      );
    },
  },
};
</script>
<style lang="scss">
input:disabled {
  cursor: default;
  border-color: #bdbdbd;
  color: #bdbdbd;
}
</style>